import api from '../api';
import { ISubjectsByClassroomResponse } from '../../interface/subjectModel';

export const fetchSubjectsByClassroomId = async (
  classroomId: string,
): Promise<ISubjectsByClassroomResponse> => {
  const response = await api.get<ISubjectsByClassroomResponse>(
    `/classroom/${classroomId}/subjects`,
  );
  return response.data;
};
